<script>
  import VisionneuseVideos from './VisionneuseVideos.vue'
  export default {
    name: 'GalerieVideos',
    components: {
      VisionneuseVideos,
    },
    props: {
      donnees: {
        type: Array,
        required: true,
        default: () => [],
      },
    },
    data() {
      return {
        estVisionneuseOuverte: false,
        compteur: 0,
      }
    },
    methods: {
      ouvrirVisionneuse(index) {
        this.compteur = index
        this.estVisionneuseOuverte = true
      },
      fermerVisionneuse() {
        this.estVisionneuseOuverte = false
      },
    },
  }
</script>

<template>
  <ul class="galerie-oeuvres">
    <li v-for="(data, index) in donnees" :key="data.id">
      <img
        class="image-galerie"
        :src="`/visuels/videos/${data.dossier}/presentation.jpg`"
        @click="ouvrirVisionneuse(index)"
        alt=""
      />
      <svg
        class="bouton-play"
        xmlns="http://www.w3.org/2000/svg"
        fill="rgba(242,242,242,0.6)"
        viewBox="0 0 16 16"
      >
        <path
          d="m11.596 8.697-6.363 3.692c-.54.313-1.233-.066-1.233-.697V4.308c0-.63.692-1.01 1.233-.696l6.363 3.692a.802.802 0 0 1 0 1.393"
        ></path>
      </svg>
    </li>
  </ul>

  <VisionneuseVideos
    v-if="estVisionneuseOuverte"
    :donnees="donnees"
    :categorie="categorie"
    :compteur-initial="compteur"
    @fermer-visionneuse="fermerVisionneuse"
  />
</template>

<style scoped>
  .galerie-oeuvres {
    margin: 0;
    margin-block-start: 0;
    margin-block-end: 0;
    padding-inline-start: 0;
    width: min(1200px, 90vw);
    display: grid;
    gap: 1em;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    list-style-type: none;
    margin: 2em 0;
  }
  .image-galerie {
    display: block;
    cursor: pointer;
    width: 100%;
    height: 100%;
    max-width: 300px;
    max-height: 300px;
    object-fit: cover;
    object-position: center;
    display: flex;
    align-items: center;
    transition: all 0.15s ease;
  }

  .image-galerie:hover {
    padding: 0.25em;
  }

  li {
    position: relative;
    display: inline-block;
  }

  .bouton-play {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    pointer-events: none;
    width: 150px;
  }
</style>
